import React, { useState } from "react";
import { Link } from "react-scroll";
import { FaTelegram, FaTwitter, FaBars, FaTimes } from "react-icons/fa";
import "./App.css";
import Tokenomics from "./pages/Tokenomics";
import About from "./pages/About";
import Disclaimer from "./pages/Disclaimer";
import Home from "./pages/Home";
import Roadmap from "./pages/Roadmap";

const App: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen); // Function to toggle the menu

  return (
    <div className="App">
      <nav>
        <div className="menu-icon" onClick={toggleMenu}>
          {menuOpen ? <FaTimes size={30} /> : <FaBars size={30} />}
        </div>
        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
          <li>
            <Link to="home" smooth={true} duration={200} onClick={toggleMenu}>
              Home
            </Link>
          </li>
          <li>
            <Link
              to="tokenomics"
              smooth={true}
              duration={200}
              onClick={toggleMenu}
            >
              Tokenomics
            </Link>
          </li>
          <li>
            <Link to="about" smooth={true} duration={200} onClick={toggleMenu}>
              About
            </Link>
          </li>
          <li>
            <Link
              to="roadmap"
              smooth={true}
              duration={200}
              onClick={toggleMenu}
            >
              Roadmap
            </Link>
          </li>
          <li>
            <Link
              to="disclaimer"
              smooth={true}
              duration={200}
              onClick={toggleMenu}
            >
              Disclaimer
            </Link>
          </li>
        </ul>
      </nav>

      <section id="home" className="home-section psychedelic">
        <Home />
      </section>

      <section id="tokenomics" className="tokenomics-section psychedelic">
        <Tokenomics />
      </section>

      <section id="about" className="about-section psychedelic">
        <About />
      </section>

      <section id="roadmap" className="roadmap-section psychedelic">
        <Roadmap />
      </section>

      <section id="disclaimer" className="disclaimer-section psychedelic">
        <Disclaimer />
      </section>
    </div>
  );
};

export default App;
